import Router from 'next/router';
import type { NextPageContext } from 'next/types';

import { getRedirectUrl } from 'Components/RouterMiddleware/RouterMiddleware.helpers';

export const getClientSideLoginPageRedirect = async (context: NextPageContext): Promise<void> => {
	await Router.push(getRedirectUrl(context?.asPath));
};
